import type { ReactNode } from "react";

/**
 * Symbole zu den Schlüsseln aus dem Konfigurator-Vertrag (README „Symbole“).
 * Kleine Inline-SVGs statt einer Symbolbibliothek – nur Striche, die Farbe
 * kommt vom umgebenden Text.
 */
const PFADE: Record<string, ReactNode> = {
  // Vorhang am Faltenband: Schiene, senkrechte Falten, gewellter Saum.
  "vorhang-falten": (
    <>
      <path d="M2 3h20" />
      <path d="M5 3v16M9.7 3v16M14.3 3v16M19 3v16" />
      <path d="M5 19c1.4 1.5 3.3 1.5 4.7 0 1.4 1.5 3.2 1.5 4.6 0 1.4 1.5 3.3 1.5 4.7 0" />
    </>
  ),
  // Wellenvorhang: Schiene und zwei Wellen.
  "vorhang-welle": (
    <>
      <path d="M2 4h20" />
      <path d="M2 11c1.7-2.7 3.3-2.7 5 0s3.3 2.7 5 0 3.3-2.7 5 0 3.3 2.7 5 0" />
      <path d="M2 18c1.7-2.7 3.3-2.7 5 0s3.3 2.7 5 0 3.3-2.7 5 0 3.3 2.7 5 0" />
    </>
  ),
  // Ösenvorhang: Stange, Ösenringe, Stoff mit Falten darunter.
  "vorhang-oesen": (
    <>
      <path d="M2 3h20" />
      <circle cx="6" cy="6.5" r="1.8" />
      <circle cx="12" cy="6.5" r="1.8" />
      <circle cx="18" cy="6.5" r="1.8" />
      <path d="M4.2 6.5v12.5M7.8 6.5V19M10.2 6.5V19M13.8 6.5V19M16.2 6.5V19M19.8 6.5v12.5" />
    </>
  ),
  // Schlaufenvorhang: Stange, Stoffschlaufen darüber gelegt, Stoff darunter.
  "vorhang-schlaufen": (
    <>
      <path d="M2 4h20" />
      <path d="M4 10V6a2 2 0 0 1 2-2 2 2 0 0 1 2 2v4M10 10V6a2 2 0 0 1 2-2 2 2 0 0 1 2 2v4M16 10V6a2 2 0 0 1 2-2 2 2 0 0 1 2 2v4" />
      <path d="M4 10v9M8 10v9M10 10v9M14 10v9M16 10v9M20 10v9" />
    </>
  ),
  // Gleichmäßig: drei gleich breite Spalten.
  "verteilung-gleich": (
    <>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M9 4v16M15 4v16" />
    </>
  ),
  // Frei: Griff mit zwei Punktspalten.
  "verteilung-frei": (
    <>
      <circle cx="9" cy="6" r="1" />
      <circle cx="9" cy="12" r="1" />
      <circle cx="9" cy="18" r="1" />
      <circle cx="15" cy="6" r="1" />
      <circle cx="15" cy="12" r="1" />
      <circle cx="15" cy="18" r="1" />
    </>
  ),
  // cm-genau: Lineal.
  "breite-genau": (
    <>
      <rect x="2" y="8" width="20" height="8" rx="1.5" />
      <path d="M6 8v3M10 8v4.5M14 8v3M18 8v4.5" />
    </>
  ),
  // Bahnen-optimiert: Pfeile nach links und rechts.
  "breite-bahnen": (
    <>
      <path d="M2 12h20" />
      <path d="m6 8-4 4 4 4" />
      <path d="m18 8 4 4-4 4" />
    </>
  ),
};

/** Symbol zu einem Schlüssel; unbekannt oder leer heißt „kein Symbol“. */
export function KonfiguratorSymbol({ name }: { name: string | null | undefined }) {
  const pfade = name ? PFADE[name] : undefined;
  if (!pfade) return null;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {pfade}
    </svg>
  );
}
